<template>
  <div class="page-wrapper register-wrapper">
    <div class="content-wrapper">
      <van-form @submit="handleCheckClick">

        <van-field
          v-model="reportNoForm.reportNo"
          name="reportNo"
          label="报告编号"
          placeholder="请输入报告编号"
          :rules="[{ required: true }]"
        />

        <van-field
            v-model="reportNoForm.entrustCompName"
            name="entrustCompName"
            label="委托单位名称"
            placeholder="请输入委托单位名称"
            :rules="[{ required: true }]"
            />

        <van-field
          v-model="reportNoForm.phone"
          name="phone"
          center
          clearable
          label="手机号"
          placeholder="请输入手机号"
          :rules="[{ required: true }]"
        >
          <template #button>
            <van-button @click="handleSmsSend" native-type="button" v-if="getCodeBtn" size="small" type="primary">发送验证码</van-button>
            <van-button disabled v-else native-type="button"  size="small" type="primary">重新发送&nbsp;&nbsp;&nbsp;&nbsp;{{count}}&nbsp;&nbsp;&nbsp;&nbsp;s</van-button>
          </template>
        </van-field>

        <van-field
          v-model="reportNoForm.validCode"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          :rules="[{ required: true }]"
        >
          <template #button>
            <van-button @click="handleSmsSend" native-type="submit" size="small" type="primary">查询</van-button>
          </template>
        </van-field>
        
      </van-form>
    </div>

    <van-popup
      v-model="reportValidResultDialogVisible"
      closeable
      position="bottom"
      :style="{ height: '70%' }"
      >
      <van-form>
        <van-field
          v-model="reportValidResultForm.acceptanceNo"
          name="acceptanceNo"
          label="中心编号"
        />
        <van-field
          v-model="reportValidResultForm.entrustCompName"
          name="entrustCompName"
          label="委托单位"
        />
        <van-field
          v-model="reportValidResultForm.productionCompName"
          name="productionCompName"
          label="生产单位"
        />
        <van-field
          v-model="reportValidResultForm.reportNo"
          name="reportNo"
          label="报告编号"
        />
         <van-field
          v-model="reportValidResultForm.testResults"
          name="testResults"
          label="检验结论"
        />    
         <van-field
          v-model="reportValidResultForm.acceptorName"
          name="acceptorName"
          label="受理人"
        />    
         <van-field
          v-model="reportValidResultForm.acceptorDate"
          name="acceptorDate"
          label="受理日期"
        />  
        <!-- <van-field
          v-model="phone"
          name="phone"
          label="委托日期"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="样品名称"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="规格信号"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="样品数量"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="商标"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="生产日期"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="批号"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="检测项目"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="检测依据"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="判定依据"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="检测结果"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="发放日期"
        /> -->
      </van-form>
    </van-popup>
    <!-- <van-dialog width="100%" v-model="registerProtocolDialogVisible" title="注册协议" show-cancel-button>
    </van-dialog> -->
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';
export default {
   data() {
    return {
      reportValidResultForm:{},
      reportNoForm:{
          entrustCompName: '',
          phone: '',
          validCode: '',
          reportNo: ''
      },
      registerDisable: false,
      count: 0,
      phone: '',
      password: '',
      confirmPassword: '',
      sms: '',
      checked: false,
      reportValidResultDialogVisible: false,
      getCodeBtn: true,
    };
  },
  methods: {
    handleSmsSend(){
      const TIME_COUNT = 60;
      const _this = this
      if(!_this.reportNoForm.phone){
            Toast.fail({
              position: 'bottom',
              message: '请先填写手机号码'
            })
            return
      }
      if (!_this.timer) {
          _this.count = TIME_COUNT;
          _this.getCodeBtn = !_this.getCodeBtn
          _this.$post('/auth/sendSms',{ phone: _this.reportNoForm.phone, type:'report_valid'})
          .then(r =>{
              if (r.data.success){
                 Toast.success({
                    position: 'bottom',
                    message: '验证码已发送 请注意查收'
                  })
              }else {  
                  Toast.fail({
                    position: 'bottom',
                    message: '验证码发送出错 请重试'
                  })
              }
          })
          .catch(e =>{
                 Toast.fail({
                    position: 'bottom',
                    message: '验证码发送出错 请重试'
                  })
          }).finally(()=>{

          });
          _this.timer = setInterval(() => {
              if (_this.count > 0 && _this.count <= TIME_COUNT) {
                  _this.count--;
              } else {
                  _this.getCodeBtn = !_this.getCodeBtn
                  clearInterval(_this.timer);
                  _this.timer = null;
              }
          }, 1000)
      }
    },
    handleCheckClick(){
        const _this = this
        _this.$post('/lims6Report/public/report/action/validationByReportNo',{..._this.reportNoForm}).then(r =>{
            if (r.data.success){
                _this.reportValidResultForm = r.data.data
                _this.reportValidResultDialogVisible = true
            }else {
              Dialog.alert({
                title: '查验失败',
                message: r.data.msg ? r.data.msg: '请联系管理员',
              }).then(() => {
                // on close
              });
            }
        }).catch(e =>{
        }).finally(()=>{
        });
    },
  },
};
</script>

<style lang="scss">
</style>
